import {Injectable} from '@angular/core';


export const U_SSO_URL = 'u-sso-url';
export const U_UTC_OFFSET = 'u-utc-offset';
export const REDIRECT_POST_LOGIN = 'redirect-post-login';
export const LOGIN_ERROR = 'login-error';
export const GRID_VIEW = 'grid-view';
export const ACTIVE_ORDER_TAB = 'active-order-tab';


export const FIXED_HEADER_ENABLED = 'fixed_header_enabled';
export const HEADER_HEIGHT = 'header_height';

export const SSO_PROVIDER = 'sso-provider';
export const ACTIVE_ORDER_WINDOW_ID = 'ACTIVE_ORDER_WINDOW_ID';
export const PRODUCT_LIST_VIEW = 'product-list-view';


@Injectable()
export class LocalStorageService {

    public getItem(key: string) {
        return localStorage.getItem(key);
    }

    public setItem (key: string, data: string) {
        localStorage.setItem(key, data);
    }

    public removeItem(key: string) {
        localStorage.removeItem(key);
    }


    public isProductListView(): boolean {
        return this.getItem(PRODUCT_LIST_VIEW) === 'true';
    }

    public setProductListView(value: boolean) {
        this.setItem(PRODUCT_LIST_VIEW, value ? 'true' : 'false');
    }

    clear() {
        localStorage.clear();
    }
}
